'use client'

import React, { FC, ReactElement } from 'react'
import Link from 'next/link'
import useLoggedIn from '@/utils/hooks/useLoggedIn'
import { cn } from '@/lib/utils'
import { LayoutGrid, Plus, Image as ImageIcon } from 'lucide-react'

const Nav: FC = (_props): ReactElement => {
	const loggedIn = useLoggedIn()

	return (
		<div className="rounded-lg border border-border bg-card p-4">
			<p className="text-sm font-semibold text-foreground">Creator Dashboard</p>
			<div className="mt-4 flex flex-col gap-0.5">
				<Link
					href="/creator-dashboard"
					className={cn(
						'flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium transition-colors',
						'bg-accent text-accent-foreground'
					)}
				>
					<LayoutGrid className="size-4" />
					My collections
				</Link>
				{loggedIn && (
					<Link
						href="/creator-dashboard/new"
						className="flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
					>
						<Plus className="size-4" />
						Create collection
					</Link>
				)}
				<Link
					href="/gallery"
					className="flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
				>
					<ImageIcon className="size-4" />
					Gallery
				</Link>
			</div>
		</div>
	)
}

export default Nav
